export const settings = {
    settingsVersion: 1001,
    showSummaryVoltage: true,
    showCurrentNotifications: true,
    
};